import { createAction } from '@ngrx/store';

const loadOffers = createAction('[Headquarter Offer List Component] Load offers');

export const HqOfferListActions = {
  loadOffers,
};
